import { z } from 'zod';

export const ZFormSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type ZForm = z.infer<typeof ZFormSchema>;
export const ZFormResponseSchema = z.array(ZFormSchema);
